import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ElectronBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if running in Electron
  const isElectron = window?.navigator?.userAgent?.toLowerCase().includes('electron');
  
  // Don't show on homepage or signup page
  const currentPath = location.pathname;
  const hideOnPaths = ['/', '/homepage', '/signup', '/login', '/dashboard'];
  const shouldShow = isElectron && !hideOnPaths.includes(currentPath);
  
  if (!shouldShow) return null;
  
  const handleBackToHome = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      console.log('[ElectronBackButton] Navigating to /homepage');
      navigate('/homepage', { replace: true });
    } catch (error) {
      console.error('[ElectronBackButton] Navigation error:', error);
      // Fallback to hash navigation
      window.location.hash = '#/homepage';
    }
  };
  
  return (
    <div className="fixed top-4 left-0 right-0 z-[9998] flex justify-center pointer-events-none">
      <button
        onClick={handleBackToHome}
        className="pointer-events-auto bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2.5 rounded-full shadow-xl flex items-center gap-2 transition-all duration-200 hover:scale-105 active:scale-95 border-2 border-white"
        title="Back to Home"
      >
        <i className="fas fa-home text-base"></i>
        <span className="font-bold text-sm">Back to Home</span>
      </button>
    </div>
  );
};

export default ElectronBackButton;
